<template>
  <div class="modal-mask" v-if="isOpen">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
          <h1 class="modalTitle">{{$t('general.areYouSure')}}</h1>
          <p v-if="additionalText">{{ additionalText }}</p>
        </div>
        <div class="d-flex">
          <button
            @click="cancel()"
            class="btn btn-outline-primary btn-block mt-4 mr-2"
          >{{$t('general.cancell')}}</button>
          <button
            @click="submit()"
            class="btn btn-primary btn-block mt-4 ml-2"
          >{{$t('general.delete')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   props: {
    additionalText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = true;
      return new Promise((resolve, reject) => {

        this.submit = (data) => {
          this.isOpen = false;
          resolve(data);
        }
        this.cancel = () => {
          this.isOpen = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 999899;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  z-index: 999999;
  width: 95%;
  max-width: 450px;
  margin: 0px auto;
  padding: 20px 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modalTitle {
  margin-top: 0;
  font-size: 22px;
  text-align: center;
}
.modalText {
  text-align: center;
  font-size: 15px;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
